import { useQuery } from '@apollo/client'
import { Select } from '@/components_deprecated'
import type {
  AllVehiclesSelectQuery,
  VehicleSelectNode,
  AllVehiclesQueryVariables} from '@/modules/vehicles';
import {
  ALL_VEHICLES_SELECT_QUERY
} from '@/modules/vehicles'

import { useState } from 'react'

interface VehicleSelectProps {
  grayed?: boolean
  onVehicleSelectedCallback: (vehicle: VehicleSelectNode | null) => void
  nullable?: boolean
}

export const VehicleSelect: React.FC<VehicleSelectProps> = ({
  grayed = false,
  nullable = false,
  onVehicleSelectedCallback = () => {},
}) => {
  /**
   * Select widget which queries vehicles with dimensions and registration number
   * so we can use it to autopopulate the route planner fields for a given vehicle.
   *
   * @param {onVehicleSelectedCallback} onVehicleSelectedCallback - Handler in the parent
   * component of this component.
   */
  const [selected, setSelected] = useState<string | null>(null)

  const { loading, data } = useQuery<
    AllVehiclesSelectQuery,
    AllVehiclesQueryVariables
  >(ALL_VEHICLES_SELECT_QUERY, {
    variables: {
      orderBy: 'registrationNumber',
    },
  })

  const vehicles = data?.allVehicles.edges.map(edge => edge.node)

  const vehicleOptions = vehicles?.map(vehicle => ({
    value: vehicle.id,
    label: vehicle.registrationNumber || vehicle.vin,
  }))

  const handleOnChange = (value: string | null) => {
    if (loading || !data) return
    setSelected(value)

    if (!value) {
      onVehicleSelectedCallback(null)
      return
    }
    const vehicle = vehicles?.find(vehicle => vehicle.id === value)

    if (vehicle === undefined) return
    onVehicleSelectedCallback(vehicle)
  }

  return (
    <Select
      searchable
      fullWidth
      grayed={grayed}
      value={selected}
      options={vehicleOptions ?? []}
      loading={loading}
      onChange={handleOnChange}
      nullable={nullable}
    />
  )
}
